import * as MortgageEarn from '@/src/experiences/mortgage-earn'
export default MortgageEarn.Screens.EarnOnMortgageDocumentUpload
